import React from "react";
import styles from "../Footer/Footer.module.css";

// importing all social media images...
import facebook from "../../images/socialmedia/facebook.png";
import instagram from "../../images/socialmedia/instagram.png";
import linkedin from "../../images/socialmedia/linkedin.png";
import pintrest from "../../images/socialmedia/pintrest.png";
import twitter from "../../images/socialmedia/twitter.png";
import youtube from "../../images/socialmedia/youtube.png";

const Footer = () => {
  return (
    <div className={styles.container}>
      {/* Locations list... */}
      <div className={styles.locations}>
        <div className={styles.heading}> Top Locations</div>
        <div className={styles.list}>
          Noida • Delhi • Gurgaon • Ghaziabad • Faridabad • Agra • Ahmedabad •
          Amritsar • Aurangabad • Bangalore • Bhopal • Bhubaneswar • Chandigarh
          • Chennai • Coimbatore • Dehradun • Greater Noida • Guwahati • Gwalior
          • Hyderabad • Indore • Jabalpur • Jaipur • Jamshedpur • Kanpur • Kochi
          • Kolkata • Kota • Lucknow • Ludhiana • Meerut • Mohali • Mumbai •
          Navi Mumbai • Mysore • Nagpur • Nashik • Patna • Panipat • Prayagraj •
          Pune • Raipur • Ranchi • Surat • Thiruvananthapuram • Vadodara •
          Varanasi • Vijayawada • Visakhapatnam
        </div>
      </div>
      {/* Contact Details... */}
      <div className={styles.contact}>
        <div className={styles.heading_2}> Contact Us</div>
        <div className={styles.footerLinks}>
          <div className={styles.mail_contact}>
            <a href="tel:7827621417"> Phone : +91 7827621417</a>
            <a href="mail:support@roservicecenter.live">
              {" "}
              Email :support@roservicecenter.live
            </a>
          </div>

          <div className={styles.Links}>
            {[
              "About Us",
              "Blog",
              "Near me",
              "Terms & Conditions",
              "Privacy Policy",
              "Contact Us",
            ].map((elem, index) => {
              return (
                <>
                  <h3>{elem}</h3>
                </>
              );
            })}
          </div>
        </div>
      </div>

      <div className={styles.social_link}>
        <div className={styles.links}>
          {/* mapping through all social media  links  */}
          {[instagram, facebook, linkedin, twitter, pintrest, youtube].map(
            (elem, index) => {
              return (
                <>
                  <img src={elem} alt={index} />
                </>
              );
            }
          )}
        </div>
        <h2>© 2021 OyeBusy Technologies Pvt. Ltd.</h2>
      </div>
    </div>
  );
};

export default Footer;
